import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDocuments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19 2.25c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0 1 19 21.75H5A1.75 1.75 0 0 1 3.25 20V4c0-.966.783-1.75 1.75-1.75h14ZM19.25 4a.25.25 0 0 0-.25-.25H5a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V4Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="m16.158 15.068.016-.216v.217h.014c.266 0 .703 0 1.077-.153.194-.08.382-.206.519-.401.137-.195.212-.444.213-.75a1.112 1.112 0 0 0-.339-.888c-.295-.287-.791-.48-1.575-.496h-.005c-.657 0-1.311.089-1.956.209a9.492 9.492 0 0 1-1.826-2.367c.26-.875.4-1.622.425-2.23.025-.624-.071-1.133-.322-1.48l-.002-.004a1.281 1.281 0 0 0-1-.506c-.49-.034-.956.194-1.193.625-.17.287-.23.63-.226.977.003.35.07.722.165 1.079.178.667.462 1.307.658 1.708A22.714 22.714 0 0 1 9.178 14.2c-1.491.65-2.282 1.186-2.702 1.611a1.752 1.752 0 0 0-.403.58 1.167 1.167 0 0 0 .58 1.45c.182.128.42.159.592.159.484 0 .969-.27 1.444-.734.467-.455.948-1.121 1.438-1.984a22.764 22.764 0 0 1 3.613-1.161 4.319 4.319 0 0 0 2.418.947Zm-4.705-7.882Zm1.018 6.16c-.47.119-.957.262-1.428.42.231-.488.448-.988.65-1.49l.012.012.001-.002c.227.32.481.634.751.932h-.114l.128.129Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorDocuments;
